import { render, staticRenderFns } from "./scanIn.vue?vue&type=template&id=1a80ccaa&"
import script from "./scanIn.vue?vue&type=script&lang=js&"
export * from "./scanIn.vue?vue&type=script&lang=js&"
import style0 from "./scanIn.vue?vue&type=style&index=0&id=1a80ccaa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports